import { GUIA_LABELS } from '@utils/guiaLabels.js'
import { barFillStyle } from '@utils/barStyle.js'
import type { PassoEstatisticas } from '@utils/passoEstatisticas.js'

interface Props {
  stats: PassoEstatisticas
  moduloPct?: number
  passoOrdem?: string
}

export function PassoEstatisticasPanel({ stats, moduloPct, passoOrdem }: Props) {
  const { linhas, percentual, pendentes } = stats

  return (
    <section className='cf3-passo-stats' aria-labelledby='passo-stats-title'>
      <div className='cf3-passo-stats__head'>
        <h2 id='passo-stats-title' className='cf3-passo-stats__title'>
          {GUIA_LABELS.situacaoDestaEtapa}
        </h2>
        <span className='cf3-passo-stats__pct' aria-live='polite'>
          {percentual}%
        </span>
      </div>

      {(passoOrdem != null || moduloPct != null) && (
        <p className='cf3-passo-stats__meta'>
          {[passoOrdem, moduloPct != null ? `${moduloPct}% deste módulo` : null]
            .filter(Boolean)
            .join(' · ')}
        </p>
      )}

      <div
        className='cf3-progresso__bar cf3-passo-stats__bar'
        role='progressbar'
        aria-valuenow={percentual}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={GUIA_LABELS.progressoDestaEtapa}
      >
        <div className='cf3-progresso__bar-fill' style={barFillStyle(percentual)} />
      </div>

      {pendentes > 0 ? (
        <p className='cf3-passo-stats__summary'>
          {pendentes} {pendentes === 1 ? 'item pendente' : 'itens pendentes'}{' '}
          {GUIA_LABELS.nestaEtapa}
        </p>
      ) : (
        <p className='cf3-passo-stats__summary cf3-passo-stats__summary--ok'>
          Tudo registrado {GUIA_LABELS.nestaEtapa}
        </p>
      )}

      <ul className='cf3-passo-stats__list'>
        {linhas.map((linha) => (
          <li
            key={linha.id}
            className={[
              'cf3-passo-stats__item',
              linha.pendente ? 'cf3-passo-stats__item--pendente' : 'cf3-passo-stats__item--ok',
            ].join(' ')}
          >
            <span className='cf3-passo-stats__dot' aria-hidden />
            <span className='cf3-passo-stats__item-body'>
              <span className='cf3-passo-stats__item-titulo'>{linha.titulo}</span>
              <span className='cf3-passo-stats__item-valor'>{linha.valor}</span>
            </span>
          </li>
        ))}
      </ul>
    </section>
  )
}
